// Supports User Timing and Performance Timeline APIs that we use to measure performance
const canUsePerfAPIs = typeof performance !== 'undefined' && ['mark', 'measure', 'getEntriesByName'].every(method => typeof performance[method] === 'function');
export const getEntriesByName = (name, type) => {
  if (canUsePerfAPIs) {
    return performance.getEntriesByName(name, type);
  }
  return [];
};
export const mark = name => {
  if (canUsePerfAPIs) {
    performance.mark(name);
  }
};
export const measure = (name, startMark, endMark) => {
  if (canUsePerfAPIs) {
    try {
      performance.measure(name, startMark, endMark);
    } catch (_unused) {
      // `performance.measure()` can throw but shouldn't in our case
    }
  }
};
export const clearMarks = name => {
  if (canUsePerfAPIs) {
    performance.clearMarks(name);
  }
};
export const clearMeasures = name => {
  if (canUsePerfAPIs) {
    performance.clearMeasures(name);
  }
};